module.exports = __webpack_public_path__ + "static/AvenirNext-Italic-574fc46a768c230e04f5d2d4f6c075cc.woff2";